const FLOW_TYPE = 'FLOW_TYPE';
const CBAND_FLOW = 'CBAND_FLOW';
const HOME_LINE = 'home_line';
const CCATTEMPTS = 'ccAttempts';
const FIVEG_LINE = '5g_line';
const IS_RESUME_FLOW = 'isResumeFlow';
const REGSKIP = 'regSkip';
const SHOW = 'show';
const COUNT = 'count';
const DELIVERY_DATE = 'deliveryDate';
const PAYMENT_CALL = 'paymentCall';
const SHOW_EID = 'showEid';
const BACK_ORDER = 'isBackOrder';
const SET_RESUME_ABANDONED = 'SET_RESUME_ABANDONED';

export {
  FLOW_TYPE,
  CBAND_FLOW,
  HOME_LINE,
  CCATTEMPTS,
  FIVEG_LINE,
  IS_RESUME_FLOW,
  REGSKIP,
  SHOW,
  COUNT,
  DELIVERY_DATE,
  PAYMENT_CALL,
  SHOW_EID,
  BACK_ORDER,
  SET_RESUME_ABANDONED,
};
